var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-digital-flop',{staticStyle:{"width":"100%","height":"50px"},attrs:{"config":_vm.config}})
}
var staticRenderFns = []

export { render, staticRenderFns }